import type { Primitives } from 'common/types'
import { Validator } from 'fluentvalidation-ts'

export class ValueValidator<T extends Primitives> extends Validator<{ value: T }> {}
